<template>
  <div class="nav-container m-header">
    <div class="navbar header-div">
      <div class="header-main">
        <div class="header-logo" @click="toHome()">
          <div class="logo-img" style="width: 30px;">
            <img class="title-img" src="../../../assets/img/logoNew.png">
          </div>
        </div>
        <div class="header-right">
          <div class="header-menu" id="headerMenu">
            <el-menu
              class="el-menu-demo"
              mode="horizontal"
              text-color="#fff"
              @select="handleSelect"
              :default-active="onRoutes">


              <template v-for="(item, index) in menuList"  v-if="showMenu(item)"  >
                <el-submenu v-if="item.children && item.children.length > 0" :key="index + 'el-submenu'" :index="item.name">
                  <template slot="title">
                    <span>{{ item.meta != null ? item.meta.title : ''}}</span>
                  </template>
                  <template v-for="(single,ium) in item.children">
                    <el-submenu v-if="single.children && single.children.length > 0"  :key="ium + 'el-submenu'" :index="single.name">
                      <template slot="title">
                        <span>{{ single.meta != null ? single.meta.title : '' }}</span>
                      </template>
                    </el-submenu>
                    <el-menu-item v-else :key="ium + single.name" :index="single.name">
                      <span>{{ single.meta != null ? single.meta.title : '' }}</span>
                    </el-menu-item>
                  </template>
                </el-submenu>
                <el-menu-item v-else :key="index + item.name" :index="item.name" class="test11111">
                  <span>{{ item.meta != null ? item.meta.title : '' }}</span>
                </el-menu-item>
              </template>

              <el-submenu index="99">
                <template slot="title">
                  <i class="avatar wk wk-touxiang"></i>{{userInfo.realname}}
                </template>
                <el-menu-item index="baseInfo">基本信息</el-menu-item>
                <el-menu-item index="applet">小程序码</el-menu-item>
                <el-menu-item index="checkPass">修改密码</el-menu-item>
                <el-menu-item index="payRights">权益付费</el-menu-item>
                <el-menu-item index="ai">AI机器人</el-menu-item>
                <el-menu-item index="zlaq">质量安全</el-menu-item>
                <el-menu-item index="help">帮助</el-menu-item>
                <el-menu-item index="logOut">退出登录</el-menu-item>
              </el-submenu>

            </el-menu>
          </div>
        </div>
      </div>
    </div>
    <!--修改密码-->
    <CheckPassWord ref="checkPassWord" v-if="checkPassWordShow"></CheckPassWord>
    <!--基本信息-->
    <header-page-base-info ref="baseInfo" v-if="baseInfoShow" @getUserInfo = getUserInfo></header-page-base-info>
    <!--资源中心-->
    <down-list ref="downList" v-if="isDownloadShow"></down-list>
    <!--字符内容-->
    <word-info ref="wordInfo" v-if="isWordInfoShow"></word-info>
    <!-- 页面布局 -->
    <page-layout-set ref="pageLayoutSet" v-if="isPageLayoutSetShow"></page-layout-set>
    <!--标准文件-->
    <std-file-view-list-dialog ref="stdFileViewList" v-if="isStdFileShow"></std-file-view-list-dialog>
    <el-drawer :with-header="false" :visible.sync="drawer" :direction="direction" :before-close="handleCloseTodoDrawer">
      <todo></todo>
    </el-drawer>
    <!-- 切换主题 -->
    <switch-theme v-if="isSwitchThemeShow" ref="switchTheme"></switch-theme>
    <!-- 公司信息 -->
    <company-info v-if="isCompanyInfoShow" ref="companyInfo"></company-info>
    <!-- 公司信息 -->
    <!-- 帮助手册弹窗 -->
    <el-dialog title="操作手册" :visible.sync="isHelpManualDialogShow" width="30%" center>
      <div style="text-align: center;">
        <p>请选择需要查看的操作手册：</p>
        <div style="margin-top: 20px;">
          <el-button type="primary" @click="openBuyerManual" style="margin: 10px; width: 200px;">采购商操作指南</el-button><br>
          <el-button type="primary" @click="openSupplierManual" style="margin: 10px; width: 200px;">供应商操作指南</el-button><br>
          <el-button type="primary" @click="openAdminManual" style="margin: 10px; width: 200px;">平台管理员操作指南</el-button>
        </div>
      </div>
    </el-dialog>

    <!--消息列表-->
    <message-list-dialog v-if="isMessageDialogShow" ref="messageListDialog" @getUnreadNum="getUnreadNum"></message-list-dialog>


    <about-info v-if="isAboutInfoShow" ref="aboutInfo"></about-info>

    <sys-remind ref="sysRemind" v-if="isSysRemindShow"></sys-remind>

    <applet-img ref="appletImg" v-if="isAppletImgShow"></applet-img>

    <!-- 权益付费图片对话框 -->
    <el-dialog title="权益付费" :visible.sync="isPayRightsDialogShow" width="400px" center>
      <div style="text-align: center;">
        <p v-if="payRightsSupplierData && payRightsSupplierData.length === 1" class="supplier-data-info">
          成交金额: {{ payRightsSupplierData[0].totalMoney || 0 }},
          服务费: {{ calculatedServiceFee || 0 }},
          收费(%): {{ payRightsSupplierData[0].commissionRate || 0 }}
        </p>
        <img :src="payRightsImageUrl" alt="权益付费二维码" style="width: 300px; height: 300px;" v-if="payRightsImageUrl" />
        <p v-else>正在加载图片...</p>
      </div>
    </el-dialog>



  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import CheckPassWord from '../../checkPassword'
    import HeaderPageBaseInfo from '../../HeaderPageBaseInfo'
    import WordInfo from "../../WordInfo";
    import store from '../../../store'
    import SwitchTheme from "../../header/SwitchTheme.vue";
    import CompanyInfo from "../../header/CompanyInfo.vue"
    import AboutInfo from "../../header/AboutInfo";
    import SysRemind from '../../../views/base/remind/sys-remind'

    import MessageListDialog from '../../../views/base/message/message-list-dialog'

    import AppletImg from '../../../views/base/applet/appletImg'

    export default {
        name: "headerPage",
        data() {
          return {
            drawer: false,
            direction: 'ltr',
            unreadNums: {
              announceCount : 1,
              allCount: 1,
            },
            selectedPath: '',           //选择的地址
            menuOptions: [],            //可选列表
            userInfo: {
              realname: '张三',
              userId:'',
              headImg:'',
              orgName:'',
              loginName:'',
            },
            menuList: [],            //常规菜单列表
            checkPassWordShow: false,
            isSwitchThemeShow: false,                   //是否显示【切换标题】
            isCompanyInfoShow: false,                   //是否显示【公司信息】
            baseInfoShow: false,
            isDownloadShow: false,        //资源中心
            isProductManualShow: false,   //产品手册
            isWordInfoShow: false,        //字符内容
            isStdFileShow: false,        //标准文件
            isStdFileButtonShow: false,        //标准文件按钮
            isPageLayoutSetShow: false,                   //是否显示【页面设置】
            isMessageButtonShow: false,                   //通知按钮
            isMessageDialogShow: false,                   //显示通知弹窗
            isAboutInfoShow: false,                       //显示通知弹窗
            isSysRemindShow: false,
            isAppletImgShow: false,
            isHelpManualDialogShow: false,                  //显示帮助手册弹窗
            isPayRightsDialogShow: false,                   //显示权益付费对话框
            payRightsImageUrl: '',                         //权益付费图片URL
            payRightsSupplierData: null,                   //权益付费供应商数据
            calculatedServiceFee: 0,                       //计算的服务费
            messageNum: 0 , //右上角消息按钮的数字显示
            warningNum: 1 , //右上角消息按钮的数字显示

          };
        },
        computed: {
          expiredStatus() {
            return this.$store.getters.expiredStatus; //获取机构类型
          },
          ...mapGetters([
            'routesLists'
          ]),
          moreMenu() {
            return [{
              command: 'baseInfo',
              divided: false,
              label: '基本信息',
              icon: 'wk wk-user'
            },
            {
              command: 'applet',
              divided: false,
              label: '小程序码',
              icon: 'wk wk-user'
            },
            {
              command: 'checkPass',
              divided: false,
              label: '修改密码',
              icon: 'wk wk-user'
            },
            {
              command: 'help',
              divided: false,
              label: 'help',
              icon: 'wk wk-help'
            },
            {
              command: 'ai',
              divided: false,
              label: 'AI机器人',
              icon: 'wk wk-help'
            },
          {
            command: 'payRights',
            divided: false,
            label: '权益付费',
            icon: 'wk wk-user'
          },
            // {
            //   command: 'switchTheme',
            //   divided: false,
            //   label: '切换主题',
            //   icon: 'wk wk-user'
            // },
            {
              command: 'logOut',
              divided: false,
              label: '退出登录',
              icon: 'wk wk-logout'
            }]
          },
          onRoutes() {
            let route = this.$route;
            if(route.meta && !!route.meta.topName){
               this.selectedPath = route.meta.topName;
            }
            let path = route.path.replace("/", "");
            return path;
          },
          orgCategory() {
            return this.$store.getters.orgCategory; //获取机构类型
          },
        },
         components: {
           CheckPassWord,
           HeaderPageBaseInfo,
           WordInfo,
           SwitchTheme,
           CompanyInfo,
           AboutInfo,
           MessageListDialog,
           SysRemind,
           AppletImg
   			 },
   			created () {
          this.$nextTick(()=>{
            this.menuOptions = this.routesLists;
            this.initMenu();       //初始化菜单列表
            this.getUserInfo();    //获取用户信息
          })
		    },
        methods: {
          //去首页
          toHome(){
            this.$router.push('/home')
          },
        	//获取登录信息
        	getUserInfo() {
            this.userInfo.userId = this.$store.state.user.userId
            this.userInfo.realname = this.$store.state.user.name

		        this.request({
	         		method:'post',
              url:'/web/service?method=tCoreUser_getUserInfo',
		        }).then((response) =>{
		          if (response && response.code === 0) {

		            this.userInfo.userId = response.data.user.id
		            this.userInfo.realname = response.data.user.userName
		            this.userInfo.orgName = response.data.user.orgName
                this.userInfo.loginName = response.data.user.loginName || ''
                if(!!response.data.user.photo){
                  this.userInfo.headImg = process.env.FILE_URL + '/web/getResource/' + response.data.user.photo;
                }
                // 更新右上角图标权限
                let serviceCodes = ',' + localStorage.getItem('serviceCodes') + ','
                if (serviceCodes.concat(',METAL_STDLIST,')){  //金属方法查看列表
                  this.isStdFileButtonShow = true;
                }
                if (serviceCodes.concat(',METAL_MESSAGE,')){  //金属方法查看列表
                  this.isMessageButtonShow = true;
                }
		          }
		        })
		      },

          handleSelect(path) {
            this.selectedPath = path;
            if(path === 'baseInfo'){  //基本信息
              this.baseInfoShow = true;
              this.$nextTick(()=>{
                this.$refs.baseInfo.init(this.userInfo.userId) ;//初始化页面
              })
            }else if(path === 'applet'){  //小程序
              this.isAppletImgShow = true;
              this.$nextTick(()=>{
                this.$refs.appletImg.init() ;//初始化页面
              })
            }else if(path === 'logOut'){  //退出登录
              this.$store.dispatch('user/logout')
                .then(() => {
                  location.reload()
                })
                .catch(() => {
                  location.reload()
                })
            }else if(path === 'checkPass'){  //修改密码
              this.checkPassWordShow = true;
              this.$nextTick(()=>{
                this.$refs.checkPassWord.init(this.userInfo.userId) ;//初始化页面
              })
            }else if(path === 'help'){  //帮助
              this.showHelpManualDialog();
            }else if(path === 'ai'){  //ai
              window.open('http://www.shuqintong.com:8099/', '_blank');
            }else if(path === 'payRights'){  //权益付费
              this.showPayRightsDialog();
            }else if(path === 'zlaq'){  //质量安全
              this.openQualitySafety();
            }else {
              this.$router.push(path)
            }
          },

          //关闭待办页面
          handleCloseTodoDrawer(done){
            done();
          },
          //打开待办的页面
          handleOpenTodoDrawer() {
            this.drawer = true;
								// this.$router.push('/report-manage');
          },
          moreMenuClick(command) {
            if (command == 'baseInfo') {  //如果是 【个人信息】
              this.baseInfoShow = true;
              this.$nextTick(()=>{
                this.$refs.baseInfo.init(this.userInfo.userId) ;//初始化页面
              })

            } else if (command == 'applet') {
              this.isAppletImgShow = true;
              this.$nextTick(()=>{
                this.$refs.appletImg.init() ;//初始化页面
              })
            }else if (command == 'logOut') {
              this.$store.dispatch('user/logout')
                .then(() => {
                  location.reload()
                })
                .catch(() => {
                  location.reload()
                })
            }else if (command == 'checkPass'){
            	this.checkPassWordShow = true;
				          this.$nextTick(()=>{
				          this.$refs.checkPassWord.init(this.userInfo.userId) ;//初始化页面
				        })
            }else if (command == 'switchTheme'){     //切换主题
            	this.isSwitchThemeShow = true;
              this.$nextTick(()=>{
                this.$refs.switchTheme.init() ;//初始化页面
              })
            }else if (command == 'companyInfo'){     //公司信息
              this.isCompanyInfoShow = true;
              this.$nextTick(()=>{
                this.$refs.companyInfo.init() ;//初始化页面
              })
            }else if (command === 'codeGenerate'){
              // this.$router.push('generate')
              window.open(this.$router.resolve('generate').href, '_blank')
            }else if (command === 'bi'){
              this.$router.push('bi')
              window.open(this.$router.resolve('bi').href, '_blank')
            }else if (command === 'download'){
              this.isDownloadShow = true;
              this.$nextTick(()=>{
                this.$refs.downList.init() ;//初始化页面
              })
            }else if (command === 'productManual'){
              this.$router.push('common-productManual')
              // this.isProductManualShow = true;
              // this.$nextTick(()=>{
              //   this.$refs.productManual.init() ;//初始化页面
              // })
            }else if (command === 'help'){
              this.showHelpManualDialog();
            }else if (command === 'layoutSet'){        //页面布局
              this.isPageLayoutSetShow = true;
              this.$nextTick(()=>{
                this.$refs.pageLayoutSet.init() ;//初始化页面
              })
            }else if (command === 'myInfo'){        //关于
              this.isAboutInfoShow = true;
              this.$nextTick(()=>{
                this.$refs.aboutInfo.init() ;//初始化页面
              })
            }else if (command === 'wordInfo'){
              this.isWordInfoShow = true;
              this.$nextTick(()=>{
                this.$refs.wordInfo.init() ;//初始化页面
              })
            }else if (command === 'ai'){
              window.open('http://www.shuqintong.com:8099/', '_blank');
            }else if (command === 'payRights'){  // 权益付费
              this.showPayRightsDialog();
            }
          },

          initWordInfo() {
            this.isWordInfoShow = true;
            this.$nextTick(()=>{
              this.$refs.wordInfo.init() ;//初始化页面
            })
          },
          // 打开文档
          initDocument() {
            this.$router.push('document-info')
          },
          // 初始化标准文件
          initStdFile() {
            this.isStdFileShow = true;
            this.$nextTick(()=>{
              this.$refs.stdFileViewList.init() ;//初始化页面
            })
          },
          // 显示帮助手册对话框
          showHelpManualDialog() {
            // 显示帮助手册弹窗
            this.isHelpManualDialogShow = true;
          },
          // 打开采购商操作指南
          openBuyerManual() {
            window.open('https://www.shuqintong.com/btb-pdfs/采购商操作指南.pdf', '_blank');
          },
          // 打开供应商操作指南
          openSupplierManual() {
            window.open('https://www.shuqintong.com/btb-pdfs/供应商操作指南.pdf', '_blank');
          },
          // 打开平台管理员操作指南
          openAdminManual() {
            window.open('https://www.shuqintong.com/btb-pdfs/平台管理员操作指南.pdf', '_blank');
          },
          //初始化系统提醒
          initSysRemind(){
            this.isSysRemindShow = true;
            this.$nextTick(()=>{
              this.$refs.sysRemind.init() ;//初始化页面
            })
          },
          //初始化菜单列表
          initMenu(){
            for (let i = 0; i < this.routesLists.length; i++) {
              let temp = this.routesLists[i];
              this.menuList.push(temp);
            }
          },
          isBeyond(widthArr) {
            let menu = document.getElementsByClassName("menuList");
            if (this.sum(widthArr) > menu[0].clientWidth) {
              this.isb = true;
              let newArr = this.data.slice(0, this.data.length - 1);
              let newWidthArr = widthArr.slice(0, this.data.length - 1);
              this.data = newArr;
              this.isBeyond(newWidthArr);
            } else {
              if (this.isb) {
                let newArr = this.data.slice(0, this.data.length - 1);
                let newWidthArr = widthArr.slice(0, this.data.length - 1);
                this.data = newArr;
                this.existing = newWidthArr.length;
              }
            }
          },
          sum(arr) {
            return arr.reduce(function (prev, curr, idx, arr) {
              return prev + curr;
            });
          },
          /** 转换菜单数据结构 */
          normalizer(node) {
            if (node.children && !node.children.length) {
              delete node.children;
            }
            return {
              id: node.menuId,
              label: node.menuName,
              children: node.children
            };
          },
          // 设置右上角 消息栏的数字增长
          addMessage(){
            if (this.isMessageButtonShow){
              this.messageNum ++;
            }
          },
          //初始化消息弹窗
          initMessageDialog(){
            this.isMessageDialogShow = true;
            this.$nextTick(()=>{
              this.$refs.messageListDialog.init();
            })
          },
          // 显示权益付费对话框
          showPayRightsDialog() {
            // 首先调用供应商组织列表接口获取数据
            this.request({
              method: 'post',
              url: '/web/service',
              params: {
                'method': 'tBusinessRelationSupplier_supplierOrgList'
              }
            }).then((supplierResponse) => {
              if (supplierResponse.code === 0 && supplierResponse.data) {
                this.payRightsSupplierData = supplierResponse.data;

                // 如果只有一个供应商，计算服务费
                if (this.payRightsSupplierData && this.payRightsSupplierData.length === 1) {
                  const supplier = this.payRightsSupplierData[0];
                  if (supplier.totalMoney && supplier.commissionRate) {
                    const totalMoney = parseFloat(supplier.totalMoney.replace(/,/g, '')) || 0;
                    const commissionRate = parseFloat(supplier.commissionRate) || 0;
                    this.calculatedServiceFee = ((totalMoney * commissionRate) / 100).toFixed(4);
                  }
                }
              }
            }).catch(error => {
              console.error('获取供应商信息失败:', error);
              this.$message.error('获取供应商信息失败');
            }).finally(() => {
              // 无论供应商信息获取成功与否，都获取二维码图片
              this.request({
                method: 'post',
                url: '/web/service',
                params: {
                  'method': 'tCoreSetting_getBasePageInfo'
                }
              }).then((response) => {
                if (response.code === 0 && response.data) {
                  const qrCodeImgId = response.data.system_qrCodeImgId;
                  if (qrCodeImgId) {
                    // 构造图片URL，使用正确的文件服务地址
                    this.payRightsImageUrl = process.env.FILE_URL + '/fileWeb/getResource/' + qrCodeImgId;
                  } else {
                    this.$message.error('未获取到权益付费二维码信息');
                  }
                } else {
                  this.$message.error(response.msg || '获取权益付费信息失败');
                }
              }).catch(error => {
                console.error('获取权益付费信息失败:', error);
                this.$message.error('获取权益付费信息失败');
              }).finally(() => {
                // 最后显示对话框
                this.isPayRightsDialogShow = true;
              });
            });
          },
          // 打开质量安全页面
          openQualitySafety() {
            return this.request({
              method:'post',
              url:'/web/service',
              params:{
                'method': 'tCoreUser_getPageInfo',
                id: this.userInfo.userId,
                type: 'edit',
              }
            }).then((response) =>{
              const fullUrl = 'https://qyf.xnzn.net/?tag=sso&tenantId=471224192084217856&loginName=' + response.data.userData.loginName;
              window.open(fullUrl, '_blank');
              })
          },
          //设置隐藏一些页面
          showMenu(menuItem){
            if(menuItem.name === 'sys-user'){
              return false;
            }

            if(this.orgCategory === '1' && (menuItem.name === 'purchase-dept' || menuItem.name === 'business-inventory' || menuItem.name === 'supplier-org'
              || menuItem.name === 'system-setting'|| menuItem.name === 'bi-web')) {
              return false;
            }
            //采购商登录
            if(this.orgCategory ==='2' && (menuItem.name === 'purchase-dept' || menuItem.name === 'supplier-org'|| menuItem.name === 'system-setting'|| menuItem.name === 'bi-web')){
              return false;
            }
            //供货商登录
            if(this.orgCategory ==='3' &&  menuItem.name === 'supplier-org'|| menuItem.name === 'bi-web'){
              return false;
            }
            if(menuItem.name=='super'){
              return false
            }

            return true;
          }

        }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

.nav-container {padding: 0;box-shadow: 0px 1px 2px #dbdbdb;z-index: 100;min-width: 1200px;font-size: 15px;}

.header-div{
  height: 60px;min-height: 60px;
  position: fixed;
  width: 100%;
  background-image: url('../../../assets/img/head-bc.png');
  z-index: 12;
  padding-left: 24px;
}

.header-main{max-width: 1366px; margin: 0px auto; position: relative;}

.header-div .header-right{position: absolute; top: 0; right: 20px; display: flex;}
.header-div .header-menu{min-width: 500px;height: 100%;overflow-x: auto;line-height: 60px;font-size: 15px;}


//.header-div .header-right .el-menu-item:hover {background:#3095FF !important;}
//.header-div .header-right .el-submenu__title:hover {background:#3095FF !important;}

//头像+名称
.header-right .avatar{
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-right: 3px;
  font-size: 22px;
  color: #fff;
  margin-top: 10px;
}

//导航栏首页。。样式效果
.header-menu .el-menu .el-menu-item.is-active{
  background: transparent !important;
  text-decoration: none;
  margin: 0 5px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.header-div .header-logo{position: absolute;top:0px; left: 0; height: 60px;line-height: 60px; cursor: pointer;}
.header-div .header-logo .logo-img{float: left;height: 60px;}
.header-div .header-logo .logo-img img{margin-top: 16px; width: 220px;}
.header-div .header-logo .logo-title {float: left;display: inline-block;color: #FFF;white-space: nowrap;font-size: 15px;text-align: center;cursor: pointer;font-weight: 500;}

.header-div .header-right .header-single{float: left;text-align: center;position: relative;}
.header-photo{height: 60px;line-height: 60px;margin-left: 30px;}
// 图标字体
.iconWord{ font-size: 17px;line-height: 60px;vertical-align:bottom;}
.omega-button {font-size: 20px;line-height: 60px;background: transparent;color: white;width: 40px;padding-left: 10px;padding-right: 10px;}



.m-header {height: 60px !important;}


.header-div .el-menu{background: rgba(24, 144, 255,0);}
.header-div .el-menu--horizontal .el-menu-item{color: #FFF;margin: 0;padding: 0 16px;font-size: 14px;}
//.header-div .el-menu--horizontal .el-menu-item:hover{background: #3d4251;opacity:0.8;}
.header-div .el-menu--horizontal>.el-submenu .el-submenu__title{color: #fff;margin: 0;padding: 0 16px;height: 60px;line-height: 60px;}
.main-table .header-div.sortableColumn + .caret-wrapper{display: block;}

// 菜单
.el-menu {overflow: hidden;}
.el-menu-item{ margin: 0 !important;}

//li的高度

.el-menu.el-menu--horizontal {border-bottom: none;}
.el-menu-item {padding: 0;margin: 0 20px;font-size: 16px;color: #2a304d;}


// 系统消息
.wk-announcement,
.wk-bell {
  color: #9DA9C2;
  cursor: pointer;
  font-size: 20px;
}

.el-badge {
  margin-right: 20px;
}

.user-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  padding-top: 14px;
}

.head-user-photo{
  height: 30px;
  width: 30px;
  border-radius: 30px;
  margin-right: 8px;
}

.head-org-name {
  color: #FFF;
  font-size: 12px;
  line-height: 12px;
  padding-top: 2px;
}

.head-user-name {
  color: rgba(255, 255, 255, 0.7);
  font-size: 10px;
}
.user-container:hover .mark {
  color: #2486e4;
}

.el-menu-item {
  padding: 0;
  margin: 0 20px;
  font-size: 16px;
  font-weight: 500;
  color: #2a304d;
  i {
    color: #5c6075;
  }
}


.el-dropdown-unarrow{
  width: 100px;
}

.header-select-main {line-height: 29px;float: left;width: 150px;height: 29px;line-height: 29px;}
.header-select-main .vue-treeselect__control {height: 29px !important;}
.header-select-main .vue-treeselect__placeholder {line-height: 29px;}
.header-select-main .vue-treeselect__single-value {line-height: 29px;}

.flex-container {
  float: right; /* 向右浮动 */
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-right: 20px;
}


//#righted{
//  float: right; /* 向右浮动 */
//  display: flex;
//}
.stdFile{ /* 右上角金属标准文件图标  */
  display: inline-block;
  width: 18px;
  height: 18px;
  background-image: url('../../../assets/img/检验标准文件.png');
  background-size: 18px;
}

/deep/ .message-tip .el-badge__content{top: 20px;}




/**********************************************菜单样式**********************************************************开始************************************************************************/
.el-menu{}


/** 设置选中效果 */
/deep/  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  background-color: transparent !important;
  color: #fff !important;
  border-bottom: 0 !important;
}

/deep/  .el-menu .el-menu-item.is-active {
  background-color: transparent !important;
  color: #fff !important;
  border-bottom: 0 !important;
}


/deep/  .header-menu .el-menu .el-menu-item:hover{background:#3095FF !important;}

/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title:hover{background-color:#3095FF !important;}


.header-menu .el-menu--horizontal>.el-menu-item{
  width: 112px;
  text-align: center;
}

.header-menu .el-menu--horizontal>.el-submenu{
  width: 112px;
  text-align: center;
}




.el-menu--popup * {color: #FFF !important;}
.el-menu--popup .el-menu-item:hover,
.el-menu--popup .el-submenu__title:hover {
background: #3095FF !important;
color: #FFF !important;
border-radius: 0 !important;
}

/* 选中状态 */
.el-menu--popup .el-menu-item.is-active {
  color: #FFF !important;
  border-radius: 0 !important;
}

.el-menu--horizontal{
  //width: 112px;
}

.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
  height: 50px !important;
  line-height: 50px !important;
  font-size: 13px;
  padding: 0 !important;
  background: #3095FF;
  text-align: center;
}

/deep/ .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
  margin-top: 2px;
}

.supplier-data-info {
  font-size: 14px;
  color: black;
  margin: 10px 0;
  line-height: 1.5;
  text-align: left;
  padding: 0 20px;
}

/* 添加自定义实心向下箭头 */
/deep/ .el-icon-arrow-down:before {
  content: '▼' !important; /* 实心向下箭头 Unicode: \25BC */
  color: #fff;
  margin-top: 2px;
  //font-size: 12px;
  //color: #909399; /* 默认颜色，可自定义 */
  //transition: transform 0.3s ease;
  //display: inline-block;
}




</style>



// WEBPACK FOOTER //
// src/components/theme/theme3/HeaderPage.vue